
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-choose-openai-model-for-chat-ui",
      function () {
        return require("private-next-pages/how-to-choose-openai-model-for-chat-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-choose-openai-model-for-chat-ui"])
      });
    }
  